/**
 * @voltxampere/ui — Arduino UNO R3 board variant (Sprint 47.5-2)
 *
 * Full Arduino UNO R3 development board: ATmega328P + USB-B + AMS1117
 * 5V regulator + 16MHz crystal + reset button + ICSP header. Sprint
 * 47.5 MVP renders as a single mcu-execution component (compact);
 * Sprint 51 polish may decompose into sub-circuit (regulator + crystal
 * + MCU separately) for educational use cases.
 *
 * Reference: Arduino UNO R3 (ATmega328P-PU, DIP-28 socketed).
 * 14 digital I/O (6 PWM), 6 analog inputs, USB-B + power jack.
 * Microchip ATmega328P datasheet + Arduino UNO R3 schematic v3.
 *
 * Engine zero-diff invariant honored — canonical `mcu-execution`
 * engine type via schemaType (Sprint 46 ADR-0067).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuArduinoUnoR3 = {
    id: "arduino-uno-r3",
    nameTr: "Arduino UNO R3 (ATmega328P, USB-B)",
    nameEn: "Arduino UNO R3 (ATmega328P, USB-B)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "Arduino UNO R3",
    schemaType: "mcu-execution",
    defaultParams: {
        family: "atmega328p",
        clockHz: 16e6,
        flashHex: "",
        instructionsPerTick: 1000,
        vSupply: 5,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-arduino-uno-r3.js.map